import moment from "moment";
import {PROMO_TYPES} from "./promoCode";
import {PRODUCT_CATEGORIES} from "../../../constants";

/**
 * return subtext with Covid-19 warning if the scale is black or white,
 * otherwise it return the normal subtext.
 * @returns {ReactElement}
 */
export const orderShipingSummarySubText = (selectedScale, shippingStageState) => {
  if (!selectedScale.shippingOptionsAvailable) {
    return (
      <p className="sub-txt text-muted">Regular
        <br/>
        <span style={{whiteSpace: "nowrap"}} className="orange-text font-italic">Due to COVID-19 there may be delays in delivery</span>
      </p>
    )
  } else {
    return <p className="sub-txt text-muted">{shippingStageState.shippingMethod.label}</p>
  }
}

/**
 * Get the formatted next charge date given the plan and optional promo code.
 * @param {Object} plan
 * @param {PromoCode} [promoCode]
 * @returns {*}
 */
export const formattedNextChargeDate = (plan, promoCode) => {
  const resultMoment = moment(plan.nextChargeDate);

  if (promoCode && promoCode.promoType === PROMO_TYPES.SUB_DELAY)
    resultMoment.add(promoCode.amount, "days");

  return resultMoment.format("MMMM D, YYYY");
};

/**
 * Determines if PayPal can be used for an order with the given line items.
 * @param {LineItem[]} lineItems
 * @returns {Boolean}
 */
export const isPayPalSupported = lineItems => {
  let numMembershipProducts = 0;

  lineItems.forEach(lineItem => {
    if (lineItem.product.category === PRODUCT_CATEGORIES.MEMBERSHIP)
      numMembershipProducts += lineItem.quantity;
  });

  // PayPal can't be used when we need to create multiple subscriptions.
  return numMembershipProducts <= 1;
};